import { Component } from '@angular/core';

@Component({
  selector: 'app-absence-request',
  templateUrl: './absence-request.component.html',
  styleUrl: './absence-request.component.scss'
})
export class AbsenceRequestComponent {

  products = [
    {
      code: "P001",
      name: "Sick Leave",
      category: "23rd-25th August 2024",
      quantity: '3 Days'
    },
    {
      code: "P002",
      name: "Work From Home",
      category: "15 rd August 2024",
      quantity: '25 Days'
    },
    {
      code: "P003",
      name: "Casual Leave",
      category: "12 rd 25th August 2024",
      quantity: '1 Day'
    },
    {
      code: "P004",
      name: "Sick Leave",
      category: "23rd 25th August 2024",
      quantity: '3 Days'
    },
    {
      code: "P005",
      name: "Bereavement Leave",
      category: "23rd 25th August 2024",
      quantity: '3 Days'
    },
    {
      code: "P006",
      name: "Sick Leave",
      category: "23rd 25th August 2024",
      quantity: '3 Days'
    },
    {
      code: "P007",
      name: "Work From Home",
      category: "15 rd August 2024",
      quantity: '25 Days'
    },
    {
      code: "P008",
      name: "Casual Leave",
      category: "12 rd 25th August 2024",
      quantity: '1 Day'
    }
  ];


}
